import React, { Component } from 'react';
import PageLoader from "../../atom/loader/pageLaoder";
import { connect } from 'react-redux';
import { getDecryptedItem } from '../../../helper/methods';

class ContactPage extends Component {
    componentDidMount() {
        let productDtls = getDecryptedItem('productDtls')
        let authDetailsStorage = localStorage.getItem("authDetailsForMF");
        let authData = JSON.parse(authDetailsStorage);
        console.log("checking at line 118: ", authData);
        let parsedData = productDtls;
        const mfArnCodeObj = parsedData.find(product => product.productType === 'MF');
        const mfArnCode = mfArnCodeObj ? mfArnCodeObj.arnCode : null;
        console.log("checking at line 11: ", mfArnCode)
        localStorage.setItem('ARNCode', mfArnCode);
        let mainPath2 = `${process.env.REACT_APP_REPORT_MF_SERVER_PATH}`
        let localpath = "http://localhost:8080"
        // let arnCode = (this.props.userDetails && this.props.userDetails.employee_ID) ? this.props.userDetails.employee_ID : ""
        let newURL = `${mainPath2}ditauth/getauth?distype=MFContact&arnCode=${mfArnCode}&authData=${JSON.stringify(authData)}`;
        console.log(newURL, "newURL")
        window.location.href = newURL
    }

    render() {
        return (
            <PageLoader />
        );
    }
}

export default ContactPage;
